import type { FC } from "react";
import styled from "@emotion/styled";
import {
  MDSButton,
  MDSIcon,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
} from "@/mds";
import { MDSIconKind } from "@/mds";
import { HeadsUpStateText, StateWrapper } from "./shared";

interface Props {
  message?: string | null;
  onRetry?: () => void;
}

export const HeadsUpErrorView: FC<Props> = ({ message, onRetry }) => {
  return (
    <StateWrapper>
      <HeadsUpStateText as="p">Unable to load Heads Up</HeadsUpStateText>
      {message ? (
        <MessageText as="p" color={MDSTextColor.Secondary} variant={MDSTextVariant.TextXs}>
          {message}
        </MessageText>
      ) : null}
      {onRetry ? (
        <RetryButton variant={MDSButtonVariant.Default} onClick={onRetry}>
          <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.RotateRight} />
          Retry
        </RetryButton>
      ) : null}
    </StateWrapper>
  );
};

const MessageText = styled(MDSText)`
  margin-top: 8px;
  margin-bottom: 8px;
`;

const RetryButton = styled(MDSButton)`
  min-width: 120px;
`;
